// extracted by mini-css-extract-plugin
module.exports = {"up-horizontal-product-small":"style_up-horizontal-product-small__T8cXz","productScrollContainer":"style_productScrollContainer__8d3_O","productList":"style_productList__pGk8R"};